import Vue from 'vue';
import VueRouter from 'vue-router';

import flappyVanocniDigitMicrosite from '@/views/flappyVanocniDigitMicrosite.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/digit-vianoce',
    name: 'flappyVianocnyDigitMicrosite',
    component: flappyVanocniDigitMicrosite,
  },
  {
    path: '/',
    name: 'flappyVianocnyDigitMicrosite',
    component: flappyVanocniDigitMicrosite,
  },
  {
    path: '/digit-vanoce',
    name: 'flappyVanocniDigitMicrosite',
    component: flappyVanocniDigitMicrosite,
  },
];

const router = new VueRouter({
  routes,
});

export default router;
